const updates = [
  {
    time: '10分钟前',
    title: '《流浪地球3》官方宣布定档2027春节，概念海报首度曝光',
    tag: '电影上映',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    time: '28分钟前',
    title: '王家卫监制新片《上海之夜》杀青，梁朝伟巩俐再度联手',
    tag: '幕后花絮',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    time: '1小时前',
    title: '暑期档总票房突破180亿，《封神第二部》以38亿领跑',
    tag: '票房黑马',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    time: '2小时前',
    title: '赵丽颖新剧片酬争议持续发酵，业内人士曝真实数字差距',
    tag: '争议事件',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    time: '3小时前',
    title: '韩国翻拍《那些年》官宣阵容，IU搭档朴叙俊引期待',
    tag: '明星动态',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    time: '5小时前',
    title: '资深娱记曝某一线导演税务问题，圈内人士称"不是空穴来风"',
    tag: '八卦揭秘',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    time: '7小时前',
    title: 'IMDb年度十佳影片公布，三部华语片入围创历史新高',
    tag: '电影评分',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    time: '9小时前',
    title: '好莱坞编剧罢工波及中国合拍项目，多部大片进度受阻',
    tag: '独家追踪',
    tagColor: 'bg-accent-100 text-accent-700',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="bg-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[960px] mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-4">
            实时追踪快讯
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
            24小时不间断更新，影视圈大小事一条不漏
          </p>

          <div className="relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300 hidden md:block"></div>

            <div className="space-y-4">
              {updates.map((item, i) => (
                <div key={i} className="flex gap-4 md:gap-6 items-start">
                  <div className="hidden md:flex w-10 h-10 flex-shrink-0 rounded-full bg-background-100 border-2 border-background-300 items-center justify-center relative z-10">
                    <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
                  </div>
                  <div className="flex-1 bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer min-w-0">
                    <div className="flex flex-wrap items-center gap-2 mb-2">
                      <span className={`px-2.5 py-0.5 rounded-full text-[11px] font-semibold ${item.tagColor}`}>
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-400">{item.time}</span>
                    </div>
                    <p className="text-sm md:text-base font-medium text-foreground-800 leading-relaxed">
                      {item.title}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}